import { __assign, __makeTemplateObject, __read, __rest, __spreadArray } from "tslib";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyMixin } from '../../theme/Typography/Typography.utils';
export var Text = forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? '300' : _b, loose = _a.loose, bold = _a.bold, _c = _a.component, component = _c === void 0 ? 'div' : _c, restProps = __rest(_a, ["variant", "loose", "bold", "component"]);
    var subVariants = [
        bold && 'bold',
        loose && 'loose',
    ].filter(Boolean);
    return (React.createElement(SText, __assign({ ref: ref, as: component, "$variant": variant, "$subVariants": subVariants }, restProps)));
});
var SText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  ", ";\n"], ["\n  margin: 0;\n  ",
    ";\n"])), function (_a) {
    var $variant = _a.$variant, $subVariants = _a.$subVariants;
    return css(typographyMixin.apply(void 0, __spreadArray(['text', $variant], __read($subVariants))));
});
var templateObject_1;
//# sourceMappingURL=Text.js.map